import V from 'gcl';

/**
 * 用于通过配置和command直接生成对应的SQL 和 数据集
 * 其中定义
 * 库名/表名/操作
 * create 建表
 * add 增加数据
 * del 删除数据
 * update 修改数据
 * select 查询数据
 * drop 删除表
 * modify 修改表
 * index 索引
 * 库名/操作
 * create 新建库
 * drop 删除库
 * @param {*} crypt 
 */
export const EMBEventFactoryDecorator = class extends V.NiDataFactory {
    constructor(factory, converter, messageSender) {
        super();
        const that = this;
        if (!factory || !converter || !messageSender) throw new Error(`${!factory ?'factory':!converter?'converter':'messageSender'}对象为空!`);
        const { _, __ } = pri(that, {
            factory,
            converter,
            messageSender,
            keys: { "add": true, "update": true, "del": true },
            //这里取反向 截取正常的数据
            commandArrIndex: { add: 0, update: 1, del: 1 },
            AutoConnection: class extends V.NiDataConnection {
                constructor() {
                    super();
                }
                async open() {
                    const conn = __.factory.createDBConnection();
                    if (conn.setParams) conn.setParams(this.params);
                    else
                        V.merge(conn.params, this.params, true);
                    pri(this, { conn });
                    await conn.open();
                    await super.open();
                }
                async close() {
                    const {
                        _,
                        __
                    } = pri(this);
                    if (__.conn && __.conn.isOpen)
                        await __.conn.close();
                    await super.close();
                }
                async invoke(cmd) {
                    if (cmd.params)
                        for (var k in cmd.params) {
                            if (!k.trim().eq(k)) {
                                cmd.params[k.trim()] = cmd.params[k];
                                delete cmd.params[k];
                            }
                        }
                        //判断是否需要发事件
                        //1.判断命令
                        //2.检测有无监听
                        //console.log('检测命令', cmd)
                    let cmds = cmd.command.split('.'); //必须三级划分
                    cmds[0] = __.messageSender.SystemID;
                    let _realCommand = cmds[2] = (cmds[2] && cmds[2].replace(/event$/i, ''));
                    let hasListen = false,
                        eventName = cmds.join('.'); //完成事件拼装
                    if (_realCommand && __.keys[_realCommand] && await __.messageSender.check(eventName)) {
                        hasListen = true;
                        !cmd.command.endsWith('event') && (cmd.command = cmd.command + 'event');
                    } else
                        cmds.length == 3 && (cmd.command = cmd.command.replace(/event$/i, '')); //过滤掉以event结尾的命令


                    __.converter.convert(cmd);
                    const conn = pri(this).__.conn;
                    let result = (conn && conn.isOpen) ? await conn.invoke(cmd) : (function() { throw new Error('数据库未连接!') })();
                    //console.log('查询结果',result);
                    //有多条时，拆分成多条消息
                    if (hasListen && result.length > 1 && result[result.length - 1].length > 0) {
                        //取回数据后 ，且是需要发监听的
                        let resultarr = result;
                        result = [resultarr[__.commandArrIndex[_realCommand]]];
                        resultarr.splice(__.commandArrIndex[_realCommand], 1);
                        let _RootMsgID = cmd.params['_RootMsgID'] && cmd.params['_RootMsgID'].value || cmd.params['_RootMsgID'],
                            _PreMsgID = cmd.params['_MsgID'] && cmd.params['_MsgID'].value || cmd.params['_MsgID'],
                            _Gen = parseInt(cmd.params['_Gen'] && cmd.params['_Gen'].value || cmd.params['_Gen'] || -1) + 1;
                        //调整方式优化处理速度
                        switch (_realCommand) {
                            case 'replace':
                                resultarr[1] && resultarr[1][0] && await __.messageSender.send(eventName.replace(/\.replace$/gi, resultarr[0].length ? '.update' : '.add'), V.merge(resultarr[1][0], {
                                    _RootMsgID,
                                    _PreMsgID,
                                    _Gen
                                }, resultarr[0].length ? {
                                    _oldData: V.toJsonString(resultarr[0][0])
                                } : {}));
                                break;
                            case 'add':
                                resultarr[0] && resultarr[0][0] && await __.messageSender.send(eventName, V.merge(resultarr[0][0], {
                                    _RootMsgID,
                                    _PreMsgID,
                                    _Gen
                                }));
                                break;
                            case 'update':
                                var i = 0;
                                await V.each(resultarr[1], async function(v) {
                                    var index = i++;
                                    await __.messageSender.send(eventName, V.merge(v, {
                                        _RootMsgID,
                                        _PreMsgID,
                                        _Gen,
                                        _oldData: V.toJsonString(resultarr[0][index])
                                    }));
                                    return false;
                                });
                                break;
                            case 'del':
                                await V.each(resultarr[0], async function(v) {
                                    await __.messageSender.send(eventName, V.merge(v, {
                                        _RootMsgID,
                                        _PreMsgID,
                                        _Gen
                                    }));
                                    return false;
                                });
                                break;
                        }
                    }
                    return result;
                }
                async commit() {
                    const conn = pri(this).__.conn;
                    return (conn && conn.isOpen) ? await pri(this).__.conn.commit() : (function() { throw new Error('数据库未连接!') })();
                }
            }
        });
    }
    createDBConnection() {
        const {
            _,
            __
        } = pri(this);
        return new __.AutoConnection();
    }
}


export default {
    EMBEventFactoryDecorator
};
const pri = V.pris();